import {Controller} from "stimulus"
import StimulusReflex from 'stimulus_reflex'

// min height and width of GameBoard
const MIN_BOARD_WIDTH_PX = 804;
const MIN_BOARD_HEIGHT_PX = 450;

export default class extends Controller {
    connect() {
        StimulusReflex.register(this);
        this.preloadAssets();
        // workaround to make sure this.stimulate is working
        setTimeout(() => {
            this.ensureDesktopDevice()
        }, 1000)
    }

    keydown(event) {
        if (!event.repeat) {
            this.handleKeydown(event.key)
        }
    }

    handleKeydown(key) {
        switch (key) {
            case 'Escape':
                if (document.getElementsByClassName('modal show').length) {
                    this.stimulate('Modal#close');
                }
                break;
            default:
        }
    }

    preloadAssets() {
        const assets = this.data.get('assets').split(', ');
        assets.forEach(src => {
            const image = new Image();
            image.src = src;
            if (!image.complete) {
                image.className += 'preload-image';
                document.body.append(image);
            }
        })
    }

    ensureDesktopDevice() {
        const {innerHeight = 0, innerWidth = 0} = window;
        if (innerHeight <= MIN_BOARD_HEIGHT_PX || innerWidth <= MIN_BOARD_WIDTH_PX) {
            const warningAccepted = Boolean(parseInt(this.data.get('mobileWarningAccepted')));
            if (!warningAccepted) {
                this.stimulate('SessionSetting#ask_accept_mobile_warning')
            }
        }
    }
}
